import React from 'react';
import { View, StyleSheet, Pressable, Text, ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import Feather from '@expo/vector-icons/Feather';
import { Paprika, PaprikaSpacing } from '../../../styles/theme';
import { PantryItemView } from '../../../redux/pantrySelectors';
import { CookList } from '../CookList';

interface Props {
  items: PantryItemView[];
  onClose: () => void;
  onItemPress: (itemId: string) => void;
  onEat: (item: PantryItemView) => void;
}

export function CookPanel({ items, onClose, onItemPress, onEat }: Props) {
  const { t } = useTranslation();

  return (
    <View style={styles.root}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.title}>{t('pantry.cook.screenTitle')}</Text>
        <Pressable onPress={onClose} hitSlop={8} style={styles.closeButton}>
          <Feather name="x" size={20} color={Paprika.textMuted} />
        </Pressable>
      </View>

      {/* Content */}
      <CookList
        items={items}
        onCook={onItemPress}
        onEat={onEat}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: Paprika.background,
    borderLeftWidth: 1,
    borderLeftColor: Paprika.hairline,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: PaprikaSpacing.md,
    paddingHorizontal: PaprikaSpacing.md,
    borderBottomWidth: 1,
    borderBottomColor: Paprika.hairline,
  },
  title: {
    fontFamily: 'Newsreader-Italic',
    fontSize: 18,
    color: Paprika.textPrimary,
  },
  closeButton: {
    padding: 8,
  },
});
